/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createValidationProblemDetailsFromDiscriminatorValue, type ValidationProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Allotment/Reject
 */
export interface RejectRequestBuilder extends BaseRequestBuilder<RejectRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     post(requestConfiguration?: RequestConfiguration<RejectRequestBuilderPostQueryParameters> | undefined) : Promise<void>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(requestConfiguration?: RequestConfiguration<RejectRequestBuilderPostQueryParameters> | undefined) : RequestInformation;
}
export interface RejectRequestBuilderPostQueryParameters {
    description?: string;
    id?: number;
    version?: number;
}
/**
 * Uri template for the request builder.
 */
export const RejectRequestBuilderUriTemplate = "{+baseurl}/Allotment/Reject?description={description}&id={id}&version={version}";
/**
 * Metadata for all the requests in the request builder.
 */
export const RejectRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: RejectRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
    },
};
/* tslint:enable */
/* eslint-enable */
